import React, {useCallback, useEffect, useState} from 'react'
import {MunshiMenu} from "../components/Menu";
import {Button} from 'primereact/button';
import {axiosInstance} from "../utilities/AxiosConfig";
import {DataTable} from 'primereact/datatable';
import {ToastContainer} from 'react-toastify';
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";

import {TreeTable} from "primereact/treetable";
import {Column} from "primereact/column";
import {Sidebar} from "primereact/sidebar";
import {ViewImages} from "../components/Image/ImageUtils";

import Cookies from "js-cookie";



import {numberWithCommas, sF} from "../utilities/NumberFormatter";
import {InventoryPrint} from "../print/InventoryPrint";
import {StockTreePrint} from "../print/StockTreePrint";
import {useMediaQuery} from "react-responsive";

import {Auths} from "../utilities/getAuthDep";


export function StockDetails({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action, setAction] = useState("Balance");
    const [action1, setAction1] = useState(null);
    const [itemGroupList, setItemGroupList] = useState([]);
    const [proceed, setProceed] = useState(false);
    const [balanceList, setBalanceList] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [showInventory, setShowInventory] = useState(false);
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const [itemList, setItemList] = useState([]);
    const [item, setItem] = useState({});
    const [group, setGroup] = useState({id: 0, name: ""});

    const [locationList, setLocationList] = useState([]);
    const [stock, setStock] = useState(0);
    const [profit, setProfit] = useState(0);
    const isDesktop = useMediaQuery({query: '(min-width: 1024px)'})
    const [bioData, setBioData] = useState({});
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [ bioRes,locRes] = await Promise.all([
                    axiosInstance.get('biodata/'),
                    axiosInstance.get('location'),
                ]);
                setBioData(bioRes.data);
                setLocationList(locRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);
    //login Level
    useEffect(() => {
        setLoading(true)
        setUser(Cookies.get('user') );
        setDatabase(Cookies.get('database'));
        setLoading(false)
    }, [])
    //loading

    //Load ItemGroup
    useEffect(() => {
        setLoading(true)
        axiosInstance.get("/itemGroup/").then((response) => {
            if (response.data && response.data.length > 0) {
                setItemGroupList(response.data)
            } else {
                notify("No Item Group Found", "error")
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, [])
    const handlePrintOptions = () => {
        StockTreePrint(itemList, bioData.name)
    }
    const inventoryHeader = () => {
        return (
            <div className="flex justify-content-end">
                <Button icon="pi pi-print" className="mr-1 pr-2"
                        onClick={() => InventoryPrint(inventory, bioData.name, item.name, "All")}
                        disabled={!proceed || inventory.length === 0}/>
            </div>
        );
    };
    const loadInventory = (id) => {
        if (Number(id) > 0) {
            setLoading(true)
            axiosInstance.get(`/item/id/${id}`).then((response) => {
                if (response.data) {
                    setItem(response.data)
                    axiosInstance.get(`/inventory/id/${id}`).then((response) => {
                        if (response.data && response.data.length > 0) {
                            setInventory(response.data)
                            setShowInventory(true)
                        } else {
                            notify("No Inventory Found", "error")
                        }
                    }).catch((error) => {
                        notify(error.message, "error")
                    })
                } else {
                    notify("No Item Found", "error")
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                () => {
                    setLoading(false)
                }
            )

        }
    }
    const resetPage = useCallback(() => {
        setItemList([])
        setInventory([])
        setProceed(false)
        setShowInventory(false)
        setAction1(null)

    })
    const applyAction = () => {
        resetPage()
        setShowInventory(false)
        setLoading(true)
        axiosInstance.get(`/inventory/stockList/`).then((response) => {
            if (response.data && response.data.length > 0) {
                setItemList(response.data)
            } else {
                notify("No Stock Found", "error")
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
                setProceed(true)
            }
        )

    }
    const OptionSelect = () => {
        return (
            <>

                    <div className="flex flex-row mb-2 ml-5 gap-2 jutify-content-end md:mt-2 ">
                        <Button label="Proceed" icon="pi pi-sinc mr-2" onClick={() => applyAction()}
                                disabled={!level.inventory()}/>
                        <Button label="Reset" icon="pi pi-refresh mr-2" onClick={() => resetPage()}/>
                        <Button icon="pi pi-print" className="mr-1 pr-2" onClick={() => handlePrintOptions()}
                                disabled={!proceed }/>
                    </div>




            </>
        )
    }
    const stockFooter = (
        <div className="flex flex-row justify-content-between">
            <div className="flex flex-row justify-content-between w-full">
                <p>Total Stock: {stock.toLocaleString()}</p>
                {level.all() && <p>Total Profit: {profit.toLocaleString()}</p>}
            </div>
        </div>
    )
    useEffect(() => {
        if (!loading && proceed && itemList.length > 0) {
            let totalStock = 0
            let totalProfit = 0
            itemList.forEach(item => {
                if (item.data.value !== "-") {
                    totalStock += sF(item.data.value)
                }
                if (item.data.profit !== "-") {
                    totalProfit += sF(item.data.profit)
                }
            })
            setStock(totalStock)
            setProfit(totalProfit)
        }
    }, [itemList, loading, proceed])
    const numBody = (rowData,column) => {
        return (
           <span>{rowData.data[column.field]==="-"?"-":numberWithCommas(rowData.data[column.field])}</span>
        )
    }
    const ShowStock = () => {
        if (!loading && proceed && itemList.length > 0) {
            return (
                <>
                    <div className="container card shadow-2">
                        <TreeTable value={itemList} tableStyle={{minWidth: '60rem'}} paginator rows={10}
                                   resizableColumns showGridlines stripedRows
                                   columnResizeMode="fit" footer={stockFooter}
                                   onRowClick={(e) => loadInventory(e.node.data.id)}
                                   className="p-treetable-sm">
                                    <Column className="text-left font-semibold" field="name"
                                            style={{width: '37%', whiteSpace: 'nowrap'}} resizeable={true}
                                            body = {({data}) => <span style={{fontSize: '9px', lineHeight: '1'}}>{data.name}</span>}
                                            header="Item Name"
                                            headerStyle={{backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                            headerClassName="text-left"
                                            expander></Column>
                                    <Column className="text-right text-xs" field="opening" style={{width: '6%'}}
                                            header="Opening"    headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>
                                    <Column className="text-right text-xs" field="purchase" style={{width: '5%'}} header="Buy"
                                            headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>
                                    <Column className="text-right text-xs" field="sale" style={{width: '5%'}} header="Sold"
                                            headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>
                                    {isDesktop && locationList.map((location, i) => (
                                        <Column key={i} className="text-right text-xs" field={location.name}
                                                style={{width: '5%'}} header={location.name.substring(0,5)}    headerStyle={{backgroundColor: '#f8f9fa' }}
                                                alignHeader={'right'}
                                        ></Column>
                                    ))}
                            <Column className="text-right text-xs font-bold" field="import" style={{width: '7%'}}
                                    header="Pending"    headerStyle={{backgroundColor: '#f8f9fa' }}
                                    alignHeader={'right'}></Column>
                                    <Column className="text-right text-xs font-bold" field="closing" style={{width: '7%'}}
                                            header="Closing"    headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>
                                {level.all() && isDesktop &&
                                    <Column className="text-right text-xs" field="cost" style={{width: '8%'}} header="Cost" body={numBody}
                                            headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>}
                                {level.all() && isDesktop &&
                                    <Column className="text-right text-xs" field="profit" style={{width: '8%'}} body={numBody}
                                            header="Profit"    headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>}
                                {level.all() && isDesktop &&
                                    <Column className="text-right text-xs" field="value" style={{width: '8%'}} body={numBody}
                                            header="Stock Val."    headerStyle={{backgroundColor: '#f8f9fa' }}
                                            alignHeader={'right'}></Column>}
                            </TreeTable>
                        </div>
                    </>
                )
            }

        }
    const ShowInventory = () => {
        const [showImage, setShowImage] = useState(false)
        const [mode, setMode] = useState("")
        const [invoiceId, setInvoiceId] = useState(0)
        const handleTableClick = (data) => {
            setMode(data.data.mode)
            setInvoiceId(data.data.invoiceId)
            if (data.data.invoiceId > 0) {
                setShowImage(true)
            }

        }
        if (inventory.length === 0) {
            return (
                <div className="card">
                    <div className="flex flex-row justify-content-center">
                        <h1>No Inventory Found</h1>
                    </div>
                </div>
            )
        } else if (showImage) {
            return (
                <>
                    {showImage ? <ViewImages invoice={invoiceId} mode={mode} showImage={showImage}
                                             setShowImage={setShowImage}/> : null}

                </>
            )
        } else {
            return (
                <>
                    <div className="card h-full">
                        <DataTable value={inventory} size="small" tableStyle={{minWidth: '50rem'}} showGridlines
                                   stripedRows onRowClick={(e) => handleTableClick(e)}
                                   paginator rows={15} header={inventoryHeader}>
                            <Column className="text-left text-xs " field="date" header="Date"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-left text-xs " field="invoiceId" header="Folio"
                                    style={{width: '5%'}} headerStyle={{width: '5%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'center'}></Column>
                            <Column className="text-left text-xs " field="customerName" header="Customer"
                                    style={{width: '5%'}} headerStyle={{width: '15%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-left text-xs " field="mode" header="Mode"
                                    style={{width: '5%'}} headerStyle={{width: '5%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-end text-xs " field="sold" header="Sale"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-end text-xs " field="purchase" header="Purchased"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-end text-xs " field="price" header="Price"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-start text-xs " field="location" header="Location"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                            <Column className="text-end text-xs " field="balance" header="Balance"
                                    style={{width: '10%'}} headerStyle={{width: '10%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'right'}></Column>
                            <Column className="text-left text-xs " field="comment" header="Comment"
                                    style={{width: '15%'}} headerStyle={{width: '15%'}}
                                    headerClassName={"text-left text-xs "}
                                    alignHeader={'left'}></Column>
                        </DataTable>

                    </div>
                </>
            )
        }

    }
    useEffect(() => {
        setBalanceList([])

        setInventory([])
        setGroup({id: 0, name: ""})

    }, [action])
    const InventoryContent = () => {
        return (
            <div className="flex flex-nowrap flex-shrink-1 justify-content-start align-content-start">
                <div className="card flex justify-content-center">
                    <Sidebar visible={showInventory} onHide={() => setShowInventory(false)} position="right"
                             className="w-10">
                        <ShowInventory/>
                    </Sidebar>
                </div>
            </div>
        )
    }
    if (!loading) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                {showInventory && <InventoryContent/>}
                <div className=" flex flex-column justify-content-start align-item-between  h-auto w-full m-2">
                        <div className="flex flex-row justify-content-between w-full mr-1">
                            <OptionSelect/>
                            <h1 className="text-start text-xl font-bold pr-3">Stock Details</h1>
                        </div>
                    <div className="flex flex-row justify-content-start w-full">
                        {proceed &&
                                <ShowStock/>}
                    </div>

                </div>
            </>
        )
    }
}

export default StockDetails;
